<template>
  <div v-if="hasLoadPaytype" class="pay-collect">
    <transition name="fade" appear>
      <div
        v-if="visibleMain"
        class="pay-collect-shadow"
        :class="{ 'transparent-bg-mode': isTransparentBgMode }"
        @click="showLeaveConfirmPopup"
      ></div>
    </transition>
    <transition
      :name="isLandscape ? 'fade' : 'slide-up'"
      appear
      @after-leave="handleReSelectProduct"
    >
      <div
        v-if="visibleMain"
        class="pay-collect-main"
        :class="[{ 'had-tax': hadTax }, { cash: paySubmitPageUrl }]"
      >
        <div class="pay-collect-main-header">
          <button class="back-btn flex-center" @click="backHandle">
            <Icon class="back-btn-ico" name="right"></Icon>
            {{ backText }}
          </button>
        </div>
        <div
          class="pay-collect-main-content"
          :class="{ 'transparent-bg-mode': isTransparentBgMode }"
        >
          <transition name="fade" :duration="{ enter: 300, leave: 0 }">
            <cash-main
              v-if="paySubmitPageUrl"
              :paySubmitPageUrl="paySubmitPageUrl"
            ></cash-main>
            <select-paytype ref="selectPaytypeRef" v-else></select-paytype>
          </transition>
        </div>
      </div>
    </transition>

    <PopupWindow
      v-if="visibleBackPopup"
      type="newPopupWindow"
      textAlign="center"
      :languages="letter"
      :title="letter.v3ConfirmLeave"
      :content="letter.v3NoSubmitOrder"
      :confirm="letter.v3ContinueSubmit"
      :cancel="letter.v3LeaveSubmit"
      @onCancel="cancelHandle"
      @onConfirm="visibleBackPopup = false"
    ></PopupWindow>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SelectPaytype from './SelectPaytype.vue';
import CashMain from '../cash/CashMain.vue';
import pay from '@mixins/officialTopupNew/pay';
import cartAddAndDetail from '@mixins/officialTopupNew/cartAddAndDetail';
import { clickButton, popupType } from '@plugins/biPoint/_configWebstoreV35';
import transparentBg from '@mixins/officialTopupNew/transparentBg';
import bridge from '@utiles/officialStore/bridge';
import { isSafari } from '@utiles/officialStore/device';
import {
  GET_PRODUCT_LIST,
  GET_SERVER_LIST
} from '@store/officialTopupNew/index';
export default {
  name: 'PayCollect',
  mixins: [pay, cartAddAndDetail, transparentBg],
  computed: {
    ...mapState({
      letter: state => state.letter,
      hasLoadPaytype: state => state.hasLoadPaytype,
      paySubmitPageUrl: state => state.paySubmitPageUrl,
      isLandscape: state => state.page.isLandscape,
      isFromGamePay: state => state.isFromGamePay
    }),
    backText() {
      if (this.paySubmitPageUrl) {
        return this.letter.back;
      } else {
        return this.letter.productSwitch;
      }
    },
    hadTax() {
      return this.isShowTax && this.isLandscape;
    }
  },
  data() {
    return {
      visibleMain: false,
      visibleBackPopup: false
    };
  },
  components: {
    SelectPaytype,
    CashMain
  },
  methods: {
    // Safari：checkout 页设置 body -webkit-overflow-scrolling，离开时还原
    updateBodyOverflowScrolling(paySubmitPageUrl) {
      // if (!isSafari()) {
      //   return;
      // }
      // if (paySubmitPageUrl) {
      //   document.body.style.setProperty('-webkit-overflow-scrolling', 'auto');
      // } else {
      //   document.body.style.removeProperty('-webkit-overflow-scrolling');
      // }
    },
    // 1、离开收银台前：二次确认
    showLeaveConfirmPopup() {
      if (this.isTransparentBgMode) {
        return;
      }
      this.visibleBackPopup = true;
    },
    // 2、离开收银台前：播动关闭动画
    beforeHandleReSelectProduct() {
      this.visibleBackPopup = false;
      this.visibleMain = false;
      clickButton({
        btnName: 'leave_submit',
        locationKey: popupType.continueSubmit
      });
      if (this.isFromGamePay) {
        this.$store.dispatch(GET_SERVER_LIST);
        this.$store.dispatch(GET_PRODUCT_LIST);
      }
    },
    backHandle() {
      if (this.isTransparentBgMode) {
        bridge.callSdkMethod('closeWebview');
        return;
      }
      if (this.paySubmitPageUrl) {
        this.reSelectPayType();
      } else {
        this.showLeaveConfirmPopup();
      }
    },
    cancelHandle(operateType) {
      if (operateType === 'close') {
        this.visibleBackPopup = false;
      } else {
        this.beforeHandleReSelectProduct();
      }
    }
    // // 触发提单
    // submitOrder() {
    //   this.visibleBackPopup = false;
    //   this.$refs.selectPaytypeRef.postOrder();
    //   clickButton({
    //     btnName: 'continue_submit',
    //     locationKey: popupType.continueSubmit
    //   });
    // }
  },
  watch: {
    hasLoadPaytype(val) {
      if (val) {
        this.visibleMain = true;
      }
    },
    paySubmitPageUrl: {
      immediate: true,
      handler(val) {
        this.updateBodyOverflowScrolling(val);
      }
    }
  },
  beforeDestroy() {
    this.updateBodyOverflowScrolling('');
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialTopupNew/_dimen.scss';
.pay-collect {
  z-index: 33;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  &-shadow {
    content: '';
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    &.transparent-bg-mode {
      background-color: transparent;
    }
  }
  &-main {
    @include g-popup-title();
    z-index: 2;
    width: 100%;
    padding: 0;
    background-color: $backgroundColor;
    border-radius: 20px 20px 0 0;

    &::before {
      opacity: 0.15;
      height: 300px;
    }

    &-header {
      z-index: 10;
      position: sticky;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 0;
      padding: 20px 30px;
      font-size: 20px;
      height: 70px;
      box-sizing: border-box;

      .back-btn {
        padding: 0;
        margin-left: -6px;
        font-size: 28px;
        font-weight: bold;
        text-align: start;
        color: #333333;

        &-ico {
          width: 30px;
          height: 30px;
          color: #333333;
          transform: rotate(180deg);
        }
      }
    }
    &-content {
      overflow: auto;
      overscroll-behavior: contain; /* 防止滚动穿透到父元素 */
      max-height: 84vh;
      min-height: 200px;
      font-size: 24px;
      color: #333333;
    }
  }
}

#ssr-page.landscape {
  .pay-collect {
    align-items: center;
    &-main {
      box-sizing: border-box;
      overflow: auto;
      width: 1390px;
      max-height: 658px;
      padding-bottom: 20px;
      border-radius: 10px;
      transition-duration: 0.3s;

      &.had-tax {
        max-height: 700px;
      }

      &-header {
        padding: 20px;
        .back-btn {
          margin: 0;
          font-size: 18px;
          font-weight: normal;
          &-ico {
            width: 24px;
            height: 24px;
          }
        }
      }

      &-content {
        overflow: visible;
        max-height: unset;
        min-height: 30vh;
      }
    }
  }

  .cash {
    &.pay-collect {
      &-main {
        width: 694px;
        height: auto;
        max-height: 90%;
        transition-duration: 0;
      }
    }
  }
}
</style>
